"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDetectScroll = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var useDetectScroll = exports.useDetectScroll = function useDetectScroll(_ref) {
  var elementRef = _ref.elementRef,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
    _ref$detectCondition = _ref.detectCondition,
    detectCondition = _ref$detectCondition === void 0 ? true : _ref$detectCondition,
    _ref$spaceWhenNotScro = _ref.spaceWhenNotScrolled,
    spaceWhenNotScrolled = _ref$spaceWhenNotScro === void 0 ? 0 : _ref$spaceWhenNotScro;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isScrolled = _useState2[0],
    setIsScrolled = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isScrolledToEnd = _useState4[0],
    setIsScrolledToEnd = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!elementRef || !detectCondition) {
      return;
    }
    var isRef = 'current' in elementRef;
    var element = isRef ? elementRef.current : elementRef;
    var _DIRECTION_DEFINITION = (0, _slicedToArray2["default"])(DIRECTION_DEFINITIONS[direction], 2),
      axis = _DIRECTION_DEFINITION[0],
      dimension = _DIRECTION_DEFINITION[1];
    if (element) {
      var handleScroll = function handleScroll() {
        var scrollPositionToCeil = Math.ceil(element["scroll".concat(axis)]);
        setIsScrolled(scrollPositionToCeil > 0);
        setIsScrolledToEnd(element["scroll".concat(dimension)] - scrollPositionToCeil - spaceWhenNotScrolled <= element["client".concat(dimension)]);
      };
      handleScroll();
      var resizeObserver = new ResizeObserver(handleScroll);
      resizeObserver.observe(element);
      var mutationObserver = new MutationObserver(handleScroll);
      mutationObserver.observe(element, {
        subtree: true,
        childList: true,
        attributes: true
      });
      var controller = new AbortController();
      element.addEventListener('scroll', handleScroll, {
        signal: controller.signal
      });
      return function () {
        controller.abort();
        resizeObserver.disconnect();
        mutationObserver.disconnect();
      };
    }
  }, [elementRef, detectCondition, direction, spaceWhenNotScrolled]);
  return {
    isScrolled: isScrolled,
    isScrolledToEnd: isScrolledToEnd
  };
};
var DIRECTION_DEFINITIONS = {
  vertical: ['Top', 'Height'],
  horizontal: ['Left', 'Width']
};
//# sourceMappingURL=useDetectScroll.js.map